<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-10">
        <h1>Wowza failover IP switcher: {{ constFailoverIp }}</h1>
        <hr><br>
        <alert :message=message :alertType=messageType v-if="showMessage"></alert>
        <br>
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Server name</th>
              <th scope="col">Main IP</th>
              <th scope="col">DC server name</th>
              <th scope="col">is active?</th>
              <th>
                <button type="button" class="btn btn-info btn-sm"
                  @click="updateServersList(constFailoverIp)">
                  update
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(server, index) in servers_list" :key="index">
              <td>{{ server.name }}</td>
              <td>{{ server.main_ip }}</td>
              <td>{{ server.dc_name }}</td>
              <td>
                <span v-if="server.is_active">Yes</span>
                <span v-else>No</span>
              </td>
              <td>
                <button v-if="!server.is_active" type="button" class="btn btn-warning btn-sm"
                  @click="changeServer(server.id)">
                  activate
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from './Alert'

const constFailoverIp = '147.135.124.95'
// const constFailoverIp = '51.81.63.118'

export default {
  data () {
    return {
      sd: 'success',
      constFailoverIp: constFailoverIp
    }
  },
  components: {
    alert: Alert
  },
  computed: {
    servers_list () {
      return this.$store.getters.serversList
    },
    current_server (id) {
      return this.$store.getters.get_server_by_id(id)
    },
    ...mapGetters({
      showMessage: 'getShowMessage',
      message: 'getMessage',
      messageType: 'getMessageType'
    })
  },
  methods: {
    changeServer (id) {
      this.$store.dispatch('changeServer', {
        name: this.name,
        failoverIp: constFailoverIp,
        serverID: id
      })
        // .then(() => {   })
        .catch((error) => {
          // eslint-disable-next-line
          console.log('Error change server', error);
          this.$router.push('/')
        })
    },
    updateServersList (failoverIp) {
      this.$store.dispatch('updateServersList', failoverIp)
        // .then(() => {   })
        .catch((error) => {
          // eslint-disable-next-line
          console.log('Error change server', error);
          this.$router.push('/')
        })
    }
  },
  beforeCreate () {
    // eslint-disable-next-line
    this.$store.dispatch('updateServersList', constFailoverIp);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Failover.vue